import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import React, { Fragment } from 'react'
import Fishx from '@fishx/core'
import { fetch } from '@fishx/rest'
import { deepmerge } from '@fishx/utils'
import userConfig from './config/config'
import App from './App'
import RootContainer from './router'

import { ConfigProvider } from '@whalecloud/fdx'

import { onEvent, removeEvent, Locale } from '@fishx/i18n'
import ant_en_US from '@whalecloud/fdx/lib/locale-provider/en_US'
import ant_zh_CN from '@whalecloud/fdx/lib/locale-provider/zh_CN'
import 'moment/locale/zh-cn'

import logger from '@fishx/logger'

import { config as configRest } from '@fishx/rest'

import createHistory from './history'
import routes from './config/routes'
import './global.less'

let getElement = null

// init entry
;(async () => {
  let runtimeConfig = userConfig
  // 方便将其他系统定义的配置项merge进来
  if ((window as any).FishxRuntimeConfig) {
    runtimeConfig = deepmerge(runtimeConfig, (window as any).FishxRuntimeConfig)
  }
  Fishx.updateConfig({ appWrapper: App, ...runtimeConfig })

  logger.setLevel('debug') // 设置默认的告警级别为 'debugger'
  if (userConfig.logger && userConfig.logger.level) {
    logger.setLevel(userConfig.logger.level)
  }

  configRest(Fishx.config.rest || {})

  const locales = {}
  const antLocal = { 'en-US': ant_en_US, 'zh-CN': ant_zh_CN }

  const getDynamicLocaleData = async function() {
    if (typeof window !== 'undefined') {
      const en_USData = await fetch('/dscm//dynamicLocale/en_US.json')
      locales['en-US'] = en_USData

      const zh_CNData = await fetch('/dscm//dynamicLocale/zh_CN.json')
      locales['zh-CN'] = zh_CNData
    }
  }
  await getDynamicLocaleData()

  const tempConfig = {
    prefixCls: 'portal',
  }
  const TopWrapper = (props: any) => {
    return (
      <Locale
        onEvent={onEvent}
        removeEvent={removeEvent}
        locales={locales}
        defaultLocale={undefined}
        antLocal={antLocal}
        configProviderConfig={tempConfig}
        ConfigProviderComponent={ConfigProvider}
      >
        {props.children}
      </Locale>
    )
  }

  undefined

  let modifiedRoutes = routes
  if (userConfig.patchRoutes) {
    modifiedRoutes = await userConfig.patchRoutes(routes)
  }

  getElement = () => {
    const Wrapper = Fishx.config.appWrapper ? Fishx.config.appWrapper : Fragment

    return (
      <TopWrapper>
        <RootContainer
          routes={modifiedRoutes}
          wrapComponent={Wrapper}
          history={Fishx.history}
        />
      </TopWrapper>
    )
  }

  Fishx.updateHistory(createHistory())
  // 用于改写把整个应用 render 到 dom 树里的方法。
  function renderOld() {
    Fishx.unmount(Fishx.config.root)
    const element = getElement()
    Fishx.bootstrap(element, '#root')
  }
  Fishx.updateConfig({ renderOld })

  if (userConfig.render) {
    userConfig.render(renderOld)
  } else {
    const element = getElement()
    Fishx.bootstrap(element, '#root')
  }
  ;(window as any).Fishx = Fishx
})()

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept('./router', () => {
    const element = getElement()
    Fishx.bootstrap(element, '#root')
  })
}
